"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddLineService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
class AddLineService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.addAlineEligibility = '/rest-api/account/addline/v1/eligibility';
        this.addLineBusinessUrl = '/rest-api/account/business/addline/v1/eligibility';
        this.clearCartUrl = '/rest-api/account/v1/business/clearCart';
    }
    getAddLineEligibility() {
        if (this.observable) {
            return this.observable;
        }
        else {
            this.observable = this.get(this.addAlineEligibility).pipe(operators_1.map((data) => data)).pipe(operators_1.share());
            return this.observable;
        }
    }
    getAddLineBusinessEligibility() {
        return this.get(this.addLineBusinessUrl).pipe(operators_1.map((data) => data));
    }
    clearCart() {
        return this.post(this.clearCartUrl).pipe(operators_1.map((data) => data));
    }
}
exports.AddLineService = AddLineService;
//# sourceMappingURL=addline.service.js.map